import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useEnrollment } from '../../../context/Enrollment/EnrollmentContext';
import EmployerCategoryForm, {
  EmployerCategoryFormData,
} from '../../../components/Enrollment/EmployerCategory/EmployerCategoryForm';
import { EnrollmentData } from '../EnrollmentData';
import FormVariant from '../../../components/Enrollment/FormVariant';
import CompanyInformationFormData from '../../../components/Enrollment/CompanyInformation/CompanyInformationFormData';
import { removeEmptyStrings } from '../../../utils/util';

const EmployerCategory = (): JSX.Element => {
  const { enrollmentData, setEnrollmentData, nextPage, activeEditPage } = useEnrollment();

  const handleSubmit = (data: EmployerCategoryFormData) => {
    removeEmptyStrings(data);
    setEnrollmentData((prevState: EnrollmentData) => {
      return {
        ...prevState,
        employerCategoryFormData: data.employerCategory,
        companyInformationFormData: {
          ...prevState.companyInformationFormData,
          dunsNumber: data.dunsNumber ?? prevState.companyInformationFormData?.dunsNumber,
          ueiSAM: data.ueiSAM ?? prevState.companyInformationFormData?.ueiSAM,
        } as CompanyInformationFormData,
      };
    });
    nextPage();
  };

  const pageTitle = activeEditPage ? 'Edit Employer Category' : 'Employer Category';
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Employer Category',
    });
  }, []);
  return (
    <section className="padding-y-4">
      <h1 className="margin-bottom-4">{pageTitle}</h1>
      <p className="usa-intro">
        To ensure we provide you with the right information you need to use E-Verify, please select the employer
        category that best describes your organization.
      </p>
      <EmployerCategoryForm
        variantType={FormVariant.ENROLLMENT}
        employerCategory={enrollmentData.employerCategoryFormData}
        dunsNumber={enrollmentData.companyInformationFormData?.dunsNumber}
        ueiSAM={enrollmentData.companyInformationFormData?.ueiSAM}
        isEditMode={!!activeEditPage}
        onSubmitForm={handleSubmit}
      />
    </section>
  );
};

export default EmployerCategory;
